import { Language } from './language';
import { TranslationMode } from './translation-mode';

export interface UserPreferencesDto {
	readonly nativeLanguage: Language;
	readonly learnedLanguage: Language;
	readonly mode: TranslationMode;
	readonly interests: string;
	readonly dailyWordCountTarget: number;
	readonly dateTimeOffset?: number | null;
	readonly timestamp: number;
}

export interface EnabledLanguagePairDto {
	readonly source: Language;
	readonly target: Language;
	readonly mode: TranslationMode;
}

export function getNewsSourceLanguage(preferences: Pick<UserPreferencesDto, 'nativeLanguage' | 'learnedLanguage' | 'mode'>): Language {
	return preferences.mode===TranslationMode.Full
			? preferences.learnedLanguage
			:preferences.nativeLanguage;
}

export function getNewsTargetLanguage(preferences: Pick<UserPreferencesDto, 'nativeLanguage' | 'learnedLanguage' | 'mode'>): Language {
	return preferences.mode===TranslationMode.Full
			? preferences.nativeLanguage
			:preferences.learnedLanguage;
}


